import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Photos.css';
import { useEffect } from 'react';


function Photos() {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  const albums = [
    { name: 'ANNUAL DAY CELEBRATION - 2025', path: '/gallery/annual-2025' },
    { name: 'MEDICINAL PLANT EXHIBITION', path: '/gallery/medicinal' },
    { name: 'ANNUAL DAY CELEBRATION', path: '/gallery/annual' },
    { name: 'SCHOOL PICNIC', path: '/gallery/picnic' },
    { name: 'OTHER EVENTS', path: '/gallery/other' },
  ];

  return (
    <div className="photos-container">
      <h2 className="photos-heading">GALLERY</h2>
      <div className="albums-grid">
        {albums.map((album) => (
          <div key={album.path} className="album-item" onClick={() => navigate(album.path)}>
            <div className="album-card">
              <h3>{album.name}</h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Photos;
